import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import _get from 'lodash/get'
import {InviteesStatus, PageStatus, ValidStatus} from './enum'

// [达人邀请用户] http://wiki.xunlei.cn/pages/viewpage.action?pageId=127597756
export const act_invite_user = createAsyncThunk(
  'SelfFission/live/master_union/act_invite_user',
  async (arg: {target_mid: number}, store: any) => {
    const resp = await http.post<HiyaRes<{toast?: string}>>(
      '/live/master_union/act_invite_user',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// [邀请用户列表] http://wiki.xunlei.cn/pages/viewpage.action?pageId=127597767
export const act_invite_list = createAsyncThunk(
  'SelfFission/live/master_union/act_invite_list',
  async (arg: any, store: any) => {
    const resp = await http.post<HiyaRes<ActInviteListRes>>(
      '/live/master_union/act_invite_list',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

interface InviteItem {
  mid: number //	被邀请者的mid
  member: {
    avatar_urls: {aspect_low: {urls: string[]}}
    name: string
  }
  avatar_url: string
  status: InviteesStatus // 0;已邀请未申请，1;已申请审核中，2;审核失败，3;入驻成功
  valid: ValidStatus // 0;无效达人，1;有效达人
}

interface ActInviteListRes {
  list: InviteItem[] // 邀请列表
  // offset: number // 下一页，被废弃，前端自行分页
  // more: boolean // 是否更多，被废弃，前端自行分页
  total_count: number // 共邀请xxx1个人
  apply_count: number // xxx2个完成入驻申请
  join_count: number // xxx3个通过审核入驻成功
  valid_count: number // xxx4个为有效达人
  status: PageStatus // 0: 邀请阶段, 1: 邀请结算，结算阶段, 2: 活动结束
  usd: number // 奖金，如果是0就隐藏
}

interface InitialStateType {
  data: Partial<ActInviteListRes>
  // offset: number
}

const initialState: InitialStateType = {
  data: {},
}

export const SelfFissionSlice = createSlice({
  name: 'SelfFission',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(act_invite_list.fulfilled, (state, action) => {
      const data = {
        ...action.payload,
        list: action.payload.list.map((item: InviteItem) => {
          return {
            ...item,
            avatar_url: _get(item.member, 'avatar_urls.aspect_low.urls[0]', ''),
          }
        }),
      }
      Object.assign(state, {
        data,
      })
    })
  },
})
export default SelfFissionSlice.reducer
export const SelfFissionActions = SelfFissionSlice.actions

export const useSelfFissionDataState = () => {
  const data = useSelector((state) => {
    return state.SelfFission.data
  })
  return data
}
